import { render, staticRenderFns } from "./optionRadio.vue?vue&type=template&id=4e34641c"
import script from "./optionRadio.vue?vue&type=script&lang=js"
export * from "./optionRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports